<template>
  <div
    class="ui-control-group terminal-control-group"
    :class="[
      `terminal-control-group--${direction}`,
      `terminal-control-group--${size}`,
      { 'terminal-control-group--joined': joined }
    ]"
    role="group"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'UiControlGroup',
  inheritAttrs: false,
  props: {
    joined: { type: Boolean, default: false },
    size: {
      type: String,
      default: 'regular',
      validator: value => ['regular', 'small'].includes(value)
    },
    direction: {
      type: String,
      default: 'horizontal',
      validator: value => ['horizontal', 'vertical'].includes(value)
    }
  }
}
</script>
